<template>
    <div class="sort-group" :class="{active: sort.col === col}">
        <div class="label">{{ name }}</div>
        <div>
            <span
                class="icon far fa-chevron-up"
                :class="{active: sort.dir === 'asc'}"
                @click="setSort({col, dir: 'asc'})"
            ></span>
            <span
                class="icon far fa-chevron-down"
                :class="{active: sort.dir === 'desc'}"
                @click="setSort({col, dir: 'desc'})"
            ></span>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapMutations } from 'vuex';
    export default {
        name: 'SortGroup',
        data() {
            return {};
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            col: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapGetters({
                sort: 'boxes/sort',
            }),
        },
        methods: {
            ...mapMutations({
                setSort: 'boxes/setSort',
            }),
        },
    };
</script>
<style lang="scss" scoped>
    .sort-group {
        padding: 0.5em;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.active .icon.active {
            background-color: $color-disabled-bg;
            border-color: $color-border !important;
        }

        .icon {
            cursor: pointer;
            margin-left: 0.5em;
            padding: 0.25em;
            transition: 0.2s border-color, 0.2s background-color;
            border: 1px solid transparent;
            @include border-radius-smaller;

            &:hover {
                border-color: $color-disabled-bg;
            }
        }
    }
</style>